/* eslint-disable */
/* tslint:disable */
/**
 * AUTO-GENERATED — do not edit manually.
 * Generated by scripts/generateHubbleApiHooks.ts
 *
 * These hooks provide pre-configured API class instances using MSAL authentication.
 * Each hook returns a singleton API instance with full autocomplete on methods.
 * Mutations (non-get/list methods) auto-trigger refetch on any useFetch watching the same API.
 */

import { useApiInstance } from "./useApiConfiguration";
import { ActivitiesApi } from "@freightsimple/generated-hubble-openapi-client/apis/ActivitiesApi";
import { AdSpendApi } from "@freightsimple/generated-hubble-openapi-client/apis/AdSpendApi";
import { AdminLogsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AdminLogsApi";
import { AgentHostPreviewsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AgentHostPreviewsApi";
import { AgentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AgentsApi";
import { AmyApi } from "@freightsimple/generated-hubble-openapi-client/apis/AmyApi";
import { ApiKeysApi } from "@freightsimple/generated-hubble-openapi-client/apis/ApiKeysApi";
import { AttachmentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AttachmentsApi";
import { BackfillsApi } from "@freightsimple/generated-hubble-openapi-client/apis/BackfillsApi";
import { CalendarStatsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CalendarStatsApi";
import { CarrierCRMApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierCRMApi";
import { CarrierDocumentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierDocumentsApi";
import { CarrierEmailsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierEmailsApi";
import { CarrierInvoiceApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierInvoiceApi";
import { CarrierInvoiceAuditApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierInvoiceAuditApi";
import { CarrierMeetingsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierMeetingsApi";
import { CarrierProBlockApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierProBlockApi";
import { CarrierRequestAuditApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierRequestAuditApi";
import { CarrierRestrictionsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierRestrictionsApi";
import { CarriersApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarriersApi";
import { ClaudeApi } from "@freightsimple/generated-hubble-openapi-client/apis/ClaudeApi";
import { CompaniesApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompaniesApi";
import { CompanyApiRateLimitsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyApiRateLimitsApi";
import { CompanyDocumentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyDocumentsApi";
import { CompanyLabelsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyLabelsApi";
import { CompanyListsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyListsApi";
import { CompanyMeetingsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyMeetingsApi";
import { CompanyWebhooksApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyWebhooksApi";
import { CustomerInvoiceApi } from "@freightsimple/generated-hubble-openapi-client/apis/CustomerInvoiceApi";
import { CustomerSpecificPricingApi } from "@freightsimple/generated-hubble-openapi-client/apis/CustomerSpecificPricingApi";
import { DialpadCallsApi } from "@freightsimple/generated-hubble-openapi-client/apis/DialpadCallsApi";
import { DocumentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/DocumentsApi";
import { EDIApi } from "@freightsimple/generated-hubble-openapi-client/apis/EDIApi";
import { EnvironmentSyncApi } from "@freightsimple/generated-hubble-openapi-client/apis/EnvironmentSyncApi";
import { ExperimentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/ExperimentsApi";
import { FreightClaimsApi } from "@freightsimple/generated-hubble-openapi-client/apis/FreightClaimsApi";
import { FrontPluginApi } from "@freightsimple/generated-hubble-openapi-client/apis/FrontPluginApi";
import { FuelSurchargeValuesApi } from "@freightsimple/generated-hubble-openapi-client/apis/FuelSurchargeValuesApi";
import { GitApi } from "@freightsimple/generated-hubble-openapi-client/apis/GitApi";
import { IntegrationsApi } from "@freightsimple/generated-hubble-openapi-client/apis/IntegrationsApi";
import { KlaviyoApi } from "@freightsimple/generated-hubble-openapi-client/apis/KlaviyoApi";
import { LookupApi } from "@freightsimple/generated-hubble-openapi-client/apis/LookupApi";
import { MapApi } from "@freightsimple/generated-hubble-openapi-client/apis/MapApi";
import { MobileDevicesApi } from "@freightsimple/generated-hubble-openapi-client/apis/MobileDevicesApi";
import { NetSuiteSyncApi } from "@freightsimple/generated-hubble-openapi-client/apis/NetSuiteSyncApi";
import { OpenApiTypesApi } from "@freightsimple/generated-hubble-openapi-client/apis/OpenApiTypesApi";
import { OperationsTaskApi } from "@freightsimple/generated-hubble-openapi-client/apis/OperationsTaskApi";
import { PeopleApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleApi";
import { PeopleInterviewsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleInterviewsApi";
import { PeoplePayrollApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeoplePayrollApi";
import { PeopleRecruitingApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleRecruitingApi";
import { PeopleSoftwareApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleSoftwareApi";
import { PeopleTeamApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleTeamApi";
import { PeopleTeamMeetingsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleTeamMeetingsApi";
import { PeopleTeamsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleTeamsApi";
import { PingApi } from "@freightsimple/generated-hubble-openapi-client/apis/PingApi";
import { PresenceApi } from "@freightsimple/generated-hubble-openapi-client/apis/PresenceApi";
import { PreviewAccessApi } from "@freightsimple/generated-hubble-openapi-client/apis/PreviewAccessApi";
import { ProfitLossApi } from "@freightsimple/generated-hubble-openapi-client/apis/ProfitLossApi";
import { PublicApiRequestsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PublicApiRequestsApi";
import { QueueApi } from "@freightsimple/generated-hubble-openapi-client/apis/QueueApi";
import { QuoteTestApi } from "@freightsimple/generated-hubble-openapi-client/apis/QuoteTestApi";
import { QuotesApi } from "@freightsimple/generated-hubble-openapi-client/apis/QuotesApi";
import { SavedCommoditiesUploadApi } from "@freightsimple/generated-hubble-openapi-client/apis/SavedCommoditiesUploadApi";
import { SavedViewsApi } from "@freightsimple/generated-hubble-openapi-client/apis/SavedViewsApi";
import { ShipmentActivityApi } from "@freightsimple/generated-hubble-openapi-client/apis/ShipmentActivityApi";
import { ShipmentInsuranceApi } from "@freightsimple/generated-hubble-openapi-client/apis/ShipmentInsuranceApi";
import { ShipmentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/ShipmentsApi";
import { SignalAlarmRulesApi } from "@freightsimple/generated-hubble-openapi-client/apis/SignalAlarmRulesApi";
import { SignalAlarmsApi } from "@freightsimple/generated-hubble-openapi-client/apis/SignalAlarmsApi";
import { SignalsApi } from "@freightsimple/generated-hubble-openapi-client/apis/SignalsApi";
import { StarredObjectsApi } from "@freightsimple/generated-hubble-openapi-client/apis/StarredObjectsApi";
import { StatsApi } from "@freightsimple/generated-hubble-openapi-client/apis/StatsApi";
import { StickiesApi } from "@freightsimple/generated-hubble-openapi-client/apis/StickiesApi";
import { SupportEmailApi } from "@freightsimple/generated-hubble-openapi-client/apis/SupportEmailApi";
import { TechnicalApi } from "@freightsimple/generated-hubble-openapi-client/apis/TechnicalApi";
import { TodosApi } from "@freightsimple/generated-hubble-openapi-client/apis/TodosApi";
import { TripwiresApi } from "@freightsimple/generated-hubble-openapi-client/apis/TripwiresApi";

export function useActivitiesApi(): ActivitiesApi {
  return useApiInstance(ActivitiesApi);
}

export function useAdSpendApi(): AdSpendApi {
  return useApiInstance(AdSpendApi);
}

export function useAdminLogsApi(): AdminLogsApi {
  return useApiInstance(AdminLogsApi);
}

export function useAgentHostPreviewsApi(): AgentHostPreviewsApi {
  return useApiInstance(AgentHostPreviewsApi);
}

export function useAgentsApi(): AgentsApi {
  return useApiInstance(AgentsApi);
}

export function useAmyApi(): AmyApi {
  return useApiInstance(AmyApi);
}

export function useApiKeysApi(): ApiKeysApi {
  return useApiInstance(ApiKeysApi);
}

export function useAttachmentsApi(): AttachmentsApi {
  return useApiInstance(AttachmentsApi);
}

export function useBackfillsApi(): BackfillsApi {
  return useApiInstance(BackfillsApi);
}

export function useCalendarStatsApi(): CalendarStatsApi {
  return useApiInstance(CalendarStatsApi);
}

export function useCarrierCRMApi(): CarrierCRMApi {
  return useApiInstance(CarrierCRMApi);
}

export function useCarrierDocumentsApi(): CarrierDocumentsApi {
  return useApiInstance(CarrierDocumentsApi);
}

export function useCarrierEmailsApi(): CarrierEmailsApi {
  return useApiInstance(CarrierEmailsApi);
}

export function useCarrierInvoiceApi(): CarrierInvoiceApi {
  return useApiInstance(CarrierInvoiceApi);
}

export function useCarrierInvoiceAuditApi(): CarrierInvoiceAuditApi {
  return useApiInstance(CarrierInvoiceAuditApi);
}

export function useCarrierMeetingsApi(): CarrierMeetingsApi {
  return useApiInstance(CarrierMeetingsApi);
}

export function useCarrierProBlockApi(): CarrierProBlockApi {
  return useApiInstance(CarrierProBlockApi);
}

export function useCarrierRequestAuditApi(): CarrierRequestAuditApi {
  return useApiInstance(CarrierRequestAuditApi);
}

export function useCarrierRestrictionsApi(): CarrierRestrictionsApi {
  return useApiInstance(CarrierRestrictionsApi);
}

export function useCarriersApi(): CarriersApi {
  return useApiInstance(CarriersApi);
}

export function useClaudeApi(): ClaudeApi {
  return useApiInstance(ClaudeApi);
}

export function useCompaniesApi(): CompaniesApi {
  return useApiInstance(CompaniesApi);
}

export function useCompanyApiRateLimitsApi(): CompanyApiRateLimitsApi {
  return useApiInstance(CompanyApiRateLimitsApi);
}

export function useCompanyDocumentsApi(): CompanyDocumentsApi {
  return useApiInstance(CompanyDocumentsApi);
}

export function useCompanyLabelsApi(): CompanyLabelsApi {
  return useApiInstance(CompanyLabelsApi);
}

export function useCompanyListsApi(): CompanyListsApi {
  return useApiInstance(CompanyListsApi);
}

export function useCompanyMeetingsApi(): CompanyMeetingsApi {
  return useApiInstance(CompanyMeetingsApi);
}

export function useCompanyWebhooksApi(): CompanyWebhooksApi {
  return useApiInstance(CompanyWebhooksApi);
}

export function useCustomerInvoiceApi(): CustomerInvoiceApi {
  return useApiInstance(CustomerInvoiceApi);
}

export function useCustomerSpecificPricingApi(): CustomerSpecificPricingApi {
  return useApiInstance(CustomerSpecificPricingApi);
}

export function useDialpadCallsApi(): DialpadCallsApi {
  return useApiInstance(DialpadCallsApi);
}

export function useDocumentsApi(): DocumentsApi {
  return useApiInstance(DocumentsApi);
}

export function useEDIApi(): EDIApi {
  return useApiInstance(EDIApi);
}

export function useEnvironmentSyncApi(): EnvironmentSyncApi {
  return useApiInstance(EnvironmentSyncApi);
}

export function useExperimentsApi(): ExperimentsApi {
  return useApiInstance(ExperimentsApi);
}

export function useFreightClaimsApi(): FreightClaimsApi {
  return useApiInstance(FreightClaimsApi);
}

export function useFrontPluginApi(): FrontPluginApi {
  return useApiInstance(FrontPluginApi);
}

export function useFuelSurchargeValuesApi(): FuelSurchargeValuesApi {
  return useApiInstance(FuelSurchargeValuesApi);
}

export function useGitApi(): GitApi {
  return useApiInstance(GitApi);
}

export function useIntegrationsApi(): IntegrationsApi {
  return useApiInstance(IntegrationsApi);
}

export function useKlaviyoApi(): KlaviyoApi {
  return useApiInstance(KlaviyoApi);
}

export function useLookupApi(): LookupApi {
  return useApiInstance(LookupApi);
}

export function useMapApi(): MapApi {
  return useApiInstance(MapApi);
}

export function useMobileDevicesApi(): MobileDevicesApi {
  return useApiInstance(MobileDevicesApi);
}

export function useNetSuiteSyncApi(): NetSuiteSyncApi {
  return useApiInstance(NetSuiteSyncApi);
}

export function useOpenApiTypesApi(): OpenApiTypesApi {
  return useApiInstance(OpenApiTypesApi);
}

export function useOperationsTaskApi(): OperationsTaskApi {
  return useApiInstance(OperationsTaskApi);
}

export function usePeopleApi(): PeopleApi {
  return useApiInstance(PeopleApi);
}

export function usePeopleInterviewsApi(): PeopleInterviewsApi {
  return useApiInstance(PeopleInterviewsApi);
}

export function usePeoplePayrollApi(): PeoplePayrollApi {
  return useApiInstance(PeoplePayrollApi);
}

export function usePeopleRecruitingApi(): PeopleRecruitingApi {
  return useApiInstance(PeopleRecruitingApi);
}

export function usePeopleSoftwareApi(): PeopleSoftwareApi {
  return useApiInstance(PeopleSoftwareApi);
}

export function usePeopleTeamApi(): PeopleTeamApi {
  return useApiInstance(PeopleTeamApi);
}

export function usePeopleTeamMeetingsApi(): PeopleTeamMeetingsApi {
  return useApiInstance(PeopleTeamMeetingsApi);
}

export function usePeopleTeamsApi(): PeopleTeamsApi {
  return useApiInstance(PeopleTeamsApi);
}

export function usePingApi(): PingApi {
  return useApiInstance(PingApi);
}

export function usePresenceApi(): PresenceApi {
  return useApiInstance(PresenceApi);
}

export function usePreviewAccessApi(): PreviewAccessApi {
  return useApiInstance(PreviewAccessApi);
}

export function useProfitLossApi(): ProfitLossApi {
  return useApiInstance(ProfitLossApi);
}

export function usePublicApiRequestsApi(): PublicApiRequestsApi {
  return useApiInstance(PublicApiRequestsApi);
}

export function useQueueApi(): QueueApi {
  return useApiInstance(QueueApi);
}

export function useQuoteTestApi(): QuoteTestApi {
  return useApiInstance(QuoteTestApi);
}

export function useQuotesApi(): QuotesApi {
  return useApiInstance(QuotesApi);
}

export function useSavedCommoditiesUploadApi(): SavedCommoditiesUploadApi {
  return useApiInstance(SavedCommoditiesUploadApi);
}

export function useSavedViewsApi(): SavedViewsApi {
  return useApiInstance(SavedViewsApi);
}

export function useShipmentActivityApi(): ShipmentActivityApi {
  return useApiInstance(ShipmentActivityApi);
}

export function useShipmentInsuranceApi(): ShipmentInsuranceApi {
  return useApiInstance(ShipmentInsuranceApi);
}

export function useShipmentsApi(): ShipmentsApi {
  return useApiInstance(ShipmentsApi);
}

export function useSignalAlarmRulesApi(): SignalAlarmRulesApi {
  return useApiInstance(SignalAlarmRulesApi);
}

export function useSignalAlarmsApi(): SignalAlarmsApi {
  return useApiInstance(SignalAlarmsApi);
}

export function useSignalsApi(): SignalsApi {
  return useApiInstance(SignalsApi);
}

export function useStarredObjectsApi(): StarredObjectsApi {
  return useApiInstance(StarredObjectsApi);
}

export function useStatsApi(): StatsApi {
  return useApiInstance(StatsApi);
}

export function useStickiesApi(): StickiesApi {
  return useApiInstance(StickiesApi);
}

export function useSupportEmailApi(): SupportEmailApi {
  return useApiInstance(SupportEmailApi);
}

export function useTechnicalApi(): TechnicalApi {
  return useApiInstance(TechnicalApi);
}

export function useTodosApi(): TodosApi {
  return useApiInstance(TodosApi);
}

export function useTripwiresApi(): TripwiresApi {
  return useApiInstance(TripwiresApi);
}
